import { Component }                      from '@angular/core';
import { MatDialogRef }                    from '@angular/material';
import { PeakService }                    from './../shared/peak.service';
import { Globals }                        from './../common/globals';

@Component({
  selector: 'sa-peak-dialog',
  template: require('./peak-dialog.component.html'),
  styles: [require('./peak-dialog.component.scss')]
})
export class PeakDialogComponent {
  public model: any;
  public peakValues = [];
  public peaksLoaded = false;

  public errors = [];
  constructor(
    public dialogRef: MatDialogRef<PeakDialogComponent>,
    public peakService: PeakService,
    public globals: Globals
  ) {
    peakService.getPeakValues().subscribe(pv => {
      this.peakValues = pv;
      this.peaksLoaded = true;
    });
  }

  save() {
    this.errors = [];
    if (this.model.peakID === null) {
        this.errors.push('Vyberte prosím špičku');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close('delete');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/peak-dialog/peak-dialog.component.ts